/* ═══════════════════════════════════════════════════════
   ROSEHAIR — ROSEGOLD Paris
   Landing Page Interactions
═══════════════════════════════════════════════════════ */

/* ─── TRACKING FUNCTION ─────────────────────────────────
   Fires Meta Pixel + GA4 events on every CTA click.
   product: 'ritual' | 'serum' | 'shampoo' | 'conditioner'
   source:  string identifying which CTA was clicked
──────────────────────────────────────────────────────── */
const PRODUCT_DATA = {
  ritual:      { name: 'ROSEHAIR Ritual',            id: 'ROSEHAIR-RITUAL',     price: 69.90, currency: 'EUR' },
  serum:       { name: 'ROSEHAIR Advanced Serum',    id: 'ROSEHAIR-SERUM',      price: 69.90, currency: 'EUR' },
  shampoo:     { name: 'ROSEHAIR Shampoo',           id: 'ROSEHAIR-SHAMPOO',    price: 29.90, currency: 'EUR' },
  conditioner: { name: 'ROSEHAIR Conditioner',       id: 'ROSEHAIR-CONDITIONER',price: 29.90, currency: 'EUR' }
};

function trackCTA(source, product) {
  const p = PRODUCT_DATA[product] || PRODUCT_DATA.ritual;

  // ── Meta Pixel ──────────────────────────────────────
  if (typeof fbq === 'function') {
    fbq('track', 'AddToCart', {
      content_ids:   [p.id],
      content_name:  p.name,
      content_type:  'product',
      value:         p.price,
      currency:      p.currency
    });
    fbq('track', 'InitiateCheckout', {
      content_ids:   [p.id],
      content_name:  p.name,
      value:         p.price,
      currency:      p.currency,
      num_items:     1
    });
  }

  // ── Google Analytics 4 ──────────────────────────────
  if (typeof gtag === 'function') {
    gtag('event', 'add_to_cart', {
      currency:  p.currency,
      value:     p.price,
      items: [{
        item_id:   p.id,
        item_name: p.name,
        price:     p.price,
        quantity:  1
      }]
    });
    gtag('event', 'begin_checkout', {
      currency:  p.currency,
      value:     p.price,
      items: [{
        item_id:   p.id,
        item_name: p.name,
        price:     p.price,
        quantity:  1
      }],
      coupon: source
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {

  /* ─── FAQ ACCORDION ──────────────────────────────── */
  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');

    question.addEventListener('click', () => {
      const isOpen = question.getAttribute('aria-expanded') === 'true';

      // Close all
      faqItems.forEach(i => {
        i.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        i.querySelector('.faq-answer').classList.remove('open');
      });

      // Open clicked if it was closed
      if (!isOpen) {
        question.setAttribute('aria-expanded', 'true');
        answer.classList.add('open');
      }
    });
  });

  /* ─── STICKY CTA ─────────────────────────────────── */
  const stickyCta = document.getElementById('stickyCta');
  const heroSection = document.getElementById('hero');

  if (stickyCta && heroSection) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          stickyCta.classList.add('visible');
        } else {
          stickyCta.classList.remove('visible');
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(heroSection);
  }

  /* ─── NAVBAR SHADOW ON SCROLL ────────────────────── */
  const navbar = document.getElementById('navbar');

  window.addEventListener('scroll', () => {
    if (window.scrollY > 60) {
      navbar.style.boxShadow = '0 4px 24px rgba(44,36,32,0.1)';
    } else {
      navbar.style.boxShadow = 'none';
    }
  }, { passive: true });

  /* ─── SCROLL REVEAL ANIMATIONS ───────────────────── */
  const revealElements = document.querySelectorAll(
    '.synergy-step, .ingredient-card, .review-card, .pricing-card, .faq-item, .stat, .cause-item'
  );

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = entry.target.style.transform
            ? entry.target.style.transform.replace('translateY(24px)', 'translateY(0)')
            : 'translateY(0)';
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  revealElements.forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    revealObserver.observe(el);
  });

  /* ─── SMOOTH SCROLL FOR ANCHOR LINKS ─────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = 80;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  /* ─── RITUAL CARD PULSE ON LOAD ──────────────────── */
  const ritualCard = document.getElementById('ritual-card');
  if (ritualCard) {
    setTimeout(() => {
      ritualCard.style.transition = 'box-shadow 0.6s ease';
      ritualCard.style.boxShadow = '0 12px 60px rgba(201,149,106,0.35)';
      setTimeout(() => {
        ritualCard.style.boxShadow = '0 12px 48px rgba(201,149,106,0.2)';
      }, 800);
    }, 1200);
  }

});
